import { render, staticRenderFns } from "./BrowseKaihatsu.vue?vue&type=template&id=6976c629&scoped=true&"
import script from "./BrowseKaihatsu.vue?vue&type=script&lang=js&"
export * from "./BrowseKaihatsu.vue?vue&type=script&lang=js&"
import style0 from "./BrowseKaihatsu.vue?vue&type=style&index=0&id=6976c629&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976c629",
  null
  
)

export default component.exports